import { Controller } from "@hotwired/stimulus"

// Owner rule 2026-09-01: unchecking a department on the client form removes
// that department's lead rows on the spot. Before this, the rows stayed (the
// hint text even promised it), so a client that left Brand Management kept
// showing its Brand Management lead on the client page and under that
// staffer's filter, which read as "still on their roster".
//
// Wired from the shared team-assignment partial: the three department
// checkboxes are targets, every staff-assignment row is a row target (rows
// added later by addStaffAssignment carry the same attribute, so Stimulus
// picks them up), and the department dropdown fires sync too.
//
// Unchecking hides the rows of that department and marks them _destroy=1;
// re-checking before save brings them back untouched. Rows the operator
// removed by hand (the x button) are left alone. Nothing runs on connect:
// a legacy client whose lead sits in a department it no longer carries is
// not silently pruned by an unrelated edit; only a deliberate uncheck (or
// the server backstop on the same flip) removes leads.
export default class extends Controller {
  static targets = ["publicity", "brandManagement", "playlisting", "row"]

  sync() {
    const checked = {
      publicity: this.checkedState("publicity"),
      brand_management: this.checkedState("brandManagement"),
      playlisting: this.checkedState("playlisting")
    }

    this.rowTargets.forEach((row) => {
      const dept = row.querySelector('select[name="staff_assignments[][department]"]')?.value
      if (!dept || !(dept in checked) || checked[dept] === null) return
      const destroy = row.querySelector(".destroy-field")

      if (!checked[dept]) {
        if (row.dataset.leadSyncPruned === "1") return
        row.dataset.leadSyncPruned = "1"
        // A saved row carries a _destroy field; a row added in this session
        // has none, so its fields are disabled instead (disabled inputs do
        // not submit), which keeps the server from creating it.
        if (destroy) destroy.value = "1"
        else row.querySelectorAll("select, input").forEach((el) => { el.disabled = true })
        row.classList.add("hidden")
      } else if (row.dataset.leadSyncPruned === "1") {
        delete row.dataset.leadSyncPruned
        if (destroy) destroy.value = "0"
        else row.querySelectorAll("select, input").forEach((el) => { el.disabled = false })
        row.classList.remove("hidden")
      }
    })
  }

  // null when the checkbox is not on the page (non-admin editors have no
  // department boxes), so those rows are never touched.
  checkedState(name) {
    const has = this[`has${name.charAt(0).toUpperCase()}${name.slice(1)}Target`]
    return has ? this[`${name}Target`].checked : null
  }
}
